export default __webpack_public_path__ + "static/media/Banner_Western.1c1937f2.jpeg";